import { useQuery } from "@tanstack/react-query";
import $api from "~@/api";

const fetchCities = async () => {
  const { data } = await $api.cities.getCities();

  return data;
};

const useCitiesQuery = () => {
  const { data, isLoading, isPending, isError } = useQuery({
    queryKey: ["cities"],
    queryFn: () => {
      return fetchCities();
    },
  });

  return { data, isLoading, isPending, isError };
};

export default useCitiesQuery;
